export default __webpack_public_path__ + "static/OpenSans-Regular-1b0809d519837cb7aad36a73433f655c.ttf";